module.exports = __webpack_public_path__ + "img/icon-location.daaac3f0.svg";